import { Decimal } from 'decimal.js'
import convert from 'convert-units'

export default {
    methods: {
        convertValue(measurement, initUnit, finalUnit) {
            if (isNaN(measurement)) {
                return 'NaN'
            }
            else if (initUnit == finalUnit) {
                return measurement
            }

            return +(Math.round(new Decimal(convert(measurement).from(initUnit).to(finalUnit)) + "e+4")  + "e-4")
        },
        analyticUnitConverter(value, unit) {
            var result = ""
            if (value > 1000000) {
                result = result.concat((value * 0.000001).toFixed(2))
                if (unit == "g") {
                    result = result.concat(" tons")
                }
            } else if (value > 1000) {
                result = result.concat((value * 0.001).toFixed(2))
                if (unit == "g") {
                    result = result.concat(" kg")
                }
            } else {
                result = result.concat(value, " ", "g")
            }
            return result
        },
        analyticUnitConverterChart(value, unit) {
            var result = {}
            if (value > 1000000) {
                result = result.concat((value * 0.000001).toFixed(2))
                if (unit == "g") {
                    result = result.concat(" tons")
                }
            } else if (value > 10000) {
                result = result.concat((value * 0.001).toFixed(2))
                if (unit == "g") {
                    result = result.concat(" kg")
                }
            } else {
                result = result.concat(value, " ", "g")
            }
            return result
        },
        generalUnitConversion(value, base, convert) {
            var ratio = this.measurementConversion.find(measurement => {
                if (measurement.base == base && measurement.convert == convert) {
                    return measurement
                }
            })
            return +(Math.round((new Decimal(value).dividedBy(ratio.value).toNumber()) + "e+4") + "e-4");
        }
    },
    data() {
        return {
            measurementConversion: [{ base: "g", convert: "kg", value: .001 },

            { base: "g", convert: "tonne", value: 1e-6 },



            { base: "g", convert: "oz", value: 0.0353 },
            { base: "g", convert: "lb", value: 0.0022 },
            { base: "c", convert: "f", value: 1 },
            { base: "ppm", convert: "mg/l", value: 1 },

            { base: "kg", convert: "tonne", value: .001 },
            { base: "oz", convert: "tonne", value: 2.835e-5 },
            { base: "lb", convert: "tonne", value: 0.000454 },


            ],
            bodyWeight: null
        }
    }
}
